/* global System */
// register component(s) with react habitat

export default { Stage: () => System.import('./index') }
